import _Close from '@lyearn/icons/dist/cjs/web/Close';
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import React__default from 'react';
import Chip from '@mui/material/Chip';
import { getClasses } from './consts.js';

var _excluded = ["className", "label", "size"];
function SelectTag(props) {
  var className = props.className,
    label = props.label,
    _props$size = props.size,
    size = _props$size === void 0 ? 'medium' : _props$size,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/React__default.createElement(Chip, _extends({
    className: className,
    classes: getClasses(size),
    deleteIcon: /*#__PURE__*/React__default.createElement(_Close, null),
    label: label
  }, rest));
}
var SelectTag$1 = /*#__PURE__*/React__default.memo(SelectTag);

export { SelectTag$1 as default };
//# sourceMappingURL=index.js.map
